module.exports = __webpack_public_path__ + "img/bleu-3.1e6d0b00.png";